import axios from 'axios'
import handleAjax, { parseCtrlUrl } from '@/service/ajax'

/* 费用中心 */

// 获取账户套餐信息
// export function getAccountPackage() {
//   return handleAjax(axios.post(parseCtrlUrl('/ecoSystem/api/v1/temp/charge/get-product-list'), {}))
// }
export function getAccountPackage() {
  return handleAjax(axios.post('/ecoSystem/api/v1/temp/charge/get-product-list', {}))
}

// 获取套餐列表
export function getPackages() {
  return handleAjax(
    axios.post('/userCenter/charge/get-buy-product', {
      hasCompany: true,
      hasPerson: true
    })
  )
}

// 生成订单
export function createOrder(params) {
  return handleAjax(axios.post('/userCenter/charge/create-product-order', params))
}

// 获取订单信息
export function getOrder(outTradeNo) {
  return handleAjax(axios.post('/userCenter/charge/get-order', { outTradeNo }))
}

// 支付订单 method: 'wx' 微信, 'ali' 支付宝
export function payOrder(orderNo) {
  return handleAjax(axios.post(`/userCenter/charge/ali-pay-order`, { orderNo }))
}

// 订单记录
export function feeListPort(orderNo) {
  return handleAjax(axios.post(`/ecoSystem/api/v1/temp/charge/get-order-list`, orderNo))
}
